import { render, staticRenderFns } from "./OrderComplete.vue?vue&type=template&id=f281aa9e&scoped=true&"
import script from "./OrderComplete.vue?vue&type=script&lang=js&"
export * from "./OrderComplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f281aa9e",
  null
  
)

export default component.exports